<template>
  <div style="width: 100%; height: 100%; overflow: hidden; position: relative">
    <!-- <img style="width: 100%; height: 100%" src="~@/assets/images/work-bg.png" /> -->
    <div class="intro-text">
      <img src="~@/assets/images/work-text.png" />
    </div>
    <div class="work-container">
      <ul>
        <li>
          <img src="~@/assets/images/work-1.png" />
          <div class="title">薪酬福利</div>
          <ul class="content">
            <li><span>·</span>超级薪水</li>
            <li><span>·</span>健全奖金</li>
            <li><span>·</span>高额弹性绩效</li>
            <li><span>·</span>年底双薪</li>
          </ul>
        </li>
        <li>
          <img src="~@/assets/images/work-2.png" />
          <div class="title">多元娱乐关怀</div>
          <ul class="content">
            <li><span>·</span>丰富饮食娱乐</li>
            <li><span>·</span>完备假期</li>
            <li><span>·</span>网红办公园区</li>
            <li><span>·</span>团建年会</li>
          </ul>
        </li>
        <li>
          <img src="~@/assets/images/work-3.png" />
          <div class="title">多通道发展</div>
          <ul class="content">
            <li><span>·</span>岗位技能培训</li>
            <li><span>·</span>定期经验分享</li>
            <li><span>·</span>多领域发展</li>
            <li><span>·</span>拓宽职业边界</li>
          </ul>
        </li>
      </ul>
      <div class="middle-text">
        <img src="~@/assets/images/work-middle-text.png" />
      </div>
      <div class="btn">
        <a href="https://campus.leniu.com/mobile_campus2023/#/" target="_blank">
          <img src="~@/assets/images/work-btn-1.png" />
        </a>
        <a
          href="https://app.mokahr.com/m/apply/leniu/36040#/home"
          target="_blank"
        >
          <img src="~@/assets/images/work-btn-2.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from "vue";
import { loadAboutPage } from "@/assets/js/preload";

onMounted(() => {
  // loadAboutPage();
});
</script>

<style lang="scss" scoped>
.intro-text {
  position: absolute;
  top: 13.6111rem;
  left: 0;
  right: 0;
  text-align: center;

  img {
    width: 91.2963rem;
    height: 4.537rem;
  }
}
.work-container {
  position: absolute;
  top: 21.5741rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  > ul {
    width: 94.9074rem;
    > li {
      position: relative;
      width: 100%;
      height: 36.2963rem;
      margin-bottom: 2.963rem;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 100%;
        height: 100%;
      }
      .title {
        position: absolute;
        left: 34.3519rem;
        top: 4.9074rem;
        width: 55.5556rem;
        text-align: center;
        font-size: 5.1852rem;
        font-weight: 700;
        font-family: "SourceHanSansCN", "Microsoft YaHei", "Arial Narrow", Arial,
          sans-serif;
        color: #2b6392;
      }
      .content {
        font-size: 3.7037rem;
        font-family: "SourceHanSansCN", "Microsoft YaHei", "Arial Narrow", Arial,
          sans-serif;
        color: #568cb9;

        display: flex;
        flex-wrap: wrap;

        position: absolute;
        // left: 43.5185rem;
        // top: 17.1296rem;
        // width: 42.5926rem;
        left: 40.5185rem;
        top: 17.1296rem;
        width: 53.5926rem;

        li {
          width: 50%;
          flex-shrink: 0;

          &:nth-child(3),
          &:nth-child(4) {
            margin-top: 2rem;
          }

          span {
            font-weight: 700;
            margin-right: 0.5556rem;
          }
        }
      }
    }
  }
  .middle-text {
    text-align: center;
    margin: 4.8148rem 0 5.8333rem;
    img {
      width: 40.463rem;
      height: 3.1481rem;
    }
  }
  .btn {
    width: 91.9444rem;
    display: flex;
    justify-content: space-between;
    img {
      width: 45.3704rem;
      height: 12.6852rem;
    }
  }
}
</style>
